.outer {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: var(--background-color-beige);
}

@media (min-width: 901px) {
  .outer {
    min-height: 100vh;
  }
}

.inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100vw;
}

@media (min-width: 901px) {
  .inner {
    width: 100%;
    max-width: 100%;
  }
}
